import { createLogic } from 'redux-logic'
import { bindRequestLogic } from './utils'
import SystemConfigTypes from '../actionTypes/systemConfig'
import { systemConfigAPI } from '../api'

const getSystemConfigList = bindRequestLogic({
  clientFunc: systemConfigAPI.getSystemConfigs,
  type: SystemConfigTypes.GET_SYSTEM_CONFIG_LIST_REQUEST,
  successType: SystemConfigTypes.GET_SYSTEM_CONFIG_LIST_SUCCESS,
  failType: SystemConfigTypes.GET_SYSTEM_CONFIG_LIST_FAILED,
  isQueryParam: true,
  modelName: 'systemConfig'
})

const updateSystemConfigs = bindRequestLogic({
  clientFunc: systemConfigAPI.updateSystemConfigs,
  type: SystemConfigTypes.UPDATE_SYSTEMS_CONFIG_REQUEST,
  successType: SystemConfigTypes.UPDATE_SYSTEMS_CONFIG_SUCCESS,
  failType: SystemConfigTypes.UPDATE_SYSTEMS_CONFIG_FAILED
})

const getModules = bindRequestLogic({
  clientFunc: systemConfigAPI.getModules,
  type: SystemConfigTypes.GET_MODULES_REQUEST,
  successType: SystemConfigTypes.GET_MODULES_SUCCESS,
  failType: SystemConfigTypes.GET_MODULES_FAILED,
  modelName: 'modules'
})

const getAllSystemConfigs = bindRequestLogic({
  clientFunc: systemConfigAPI.getAllSystemConfigs,
  type: SystemConfigTypes.GET_ALL_SYSTEM_CONFIGS_REQUEST,
  successType: SystemConfigTypes.GET_ALL_SYSTEM_CONFIGS_SUCCESS,
  failType: SystemConfigTypes.GET_ALL_SYSTEM_CONFIGS_FAILED
})

const getAdminPortals = bindRequestLogic({
  clientFunc: systemConfigAPI.getAdminPortals,
  type: SystemConfigTypes.GET_ADMIN_PORTALS_REQUEST,
  successType: SystemConfigTypes.GET_ADMIN_PORTALS_SUCCESS,
  failType: SystemConfigTypes.GET_ADMIN_PORTALS_FAILED,
  modelName: 'items'
})

const getModuleByName = createLogic({
  type: SystemConfigTypes.GET_MODULE_BY_NAME_REQUEST,
  latest: true,
  async process({ action }, dispatch, done) {
    const { onSuccess, onError } = action.meta
    try {
      const res = await systemConfigAPI.getModuleByName(action?.payload)
      dispatch({
        type: SystemConfigTypes.GET_MODULE_BY_NAME_SUCCESS,
        payload: res
      })
      onSuccess(res?.data?.module)
    } catch (error) {
      dispatch({
        type: SystemConfigTypes.GET_MODULE_BY_NAME_FAILED,
        payload: error.message,
        meta: {}
      })
      onError(error.message)
    }
    done()
  }
})

export default [
  getSystemConfigList,
  updateSystemConfigs,
  getModules,
  getAllSystemConfigs,
  getAdminPortals,
  getModuleByName
]
